// axiosHelper.ts
import axios from 'axios'

const ROUTER_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000'

// Create an instance of axios with default config
const axiosInstance = axios.create({
  withCredentials: true, // Set withCredentials to true by default
  baseURL: ROUTER_URL,
})

// if (import.meta.env.MODE === 'development') {
//   // Optionally, you can add interceptors for request and response here
//   axiosInstance.interceptors.request.use((request) => {
//     // Do something before request is sent
//     console.log('Starting Request', JSON.stringify(request, null, 2))
//     return request
//   })
//
//   axiosInstance.interceptors.response.use(
//     (response) => {
//       // Do something with response data
//       console.log('Response:', JSON.stringify(response, null, 2))
//       return response
//     },
//     (error) => {
//       // Do something with response error
//       return Promise.reject(error)
//     }
//   )
// }

export default axiosInstance
